import React, { useState } from "react";
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import BulkEdit from "./BulkEdit";
import Alerts from "./Alerts";
import EditAlerts from "./EditAlerts";
import PowerBIReportEmbed from "../../../pages/PowerBIReportEmbed";
import { setViewPowerBi } from '../../../store/Actions';
import {setPowerBiData} from '../../../store/Actions';

function ViewAllAlerts({ viewAll, handleClose, setViewPowerBi, viewPowerBi }) {
  const [openBulkEdit, setOpenBulkEdit] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [payloadIncrease, setPayloadIncrease] = useState(0);
  const [costReduction, setCostReduction] = useState(0);
  const [payloadDecrease, setPayloadDecrease] = useState(0);
  const [onSave, setOnsave] = useState(false);
  const [fileDataList, setFileDataList] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [editAlertLoading, setEditAlertLoading] = useState(false);
  const dispatch = useDispatch();

  const toggleViewPowerBi = (data) => {    
    dispatch(setPowerBiData(data)); 
    setSelectedData(data);
    setViewPowerBi(!viewPowerBi);
  };

  const toggleEditDialog = () => setOpenEdit((prev) => !prev);
  const toggleBulkEditDialog = () => setOpenBulkEdit((prev) => !prev);

  const handleEditClose = () => {
    if (fileDataList.length > 0) {
      setFileDataList([]);
      setOpenEdit(true);
      setOpenBulkEdit(true);
    } else {
      setOpenEdit(false);
    }
  };

  const handleSave = (newPayloadIncrease, newCostReduction, newPayloadDecrease) => {
    setPayloadIncrease(newPayloadIncrease);
    setCostReduction(newCostReduction);
    setPayloadDecrease(newPayloadDecrease);
  };

  return (
    <>
      {!viewPowerBi ? (
        <>
          <Alerts
            open={viewAll}
            handleEditClick={toggleEditDialog}
            handleAlertClose={handleClose}
            onSave={onSave}
            openEdit={openEdit}
            setOnsave={setOnsave}
            handleViewPowerBi={toggleViewPowerBi}
          />
          <EditAlerts
            setOnsave={setOnsave}
            onSave={onSave}
            openEdit={openEdit}
            handleEditClose={handleEditClose}
            handleBulkEdit={toggleBulkEditDialog}
            payloadIncrease={payloadIncrease}
            costReduction={costReduction}
            payloadDecrease={payloadDecrease}
            fileData={fileDataList}
            editAlertLoading={editAlertLoading}
            setEditAlertLoading={setEditAlertLoading}
          />
          <BulkEdit
            setOnsave={setOnsave}
            openBulkEdit={openBulkEdit}
            handleBulkEditClose={toggleBulkEditDialog}
            handleSave={handleSave}
            payloadIncrease={payloadIncrease}
            costReduction={costReduction}
            payloadDecrease={payloadDecrease}
            onFileData={setFileDataList}
            editAlertLoading={editAlertLoading}
            setEditAlertLoading={setEditAlertLoading}
          />
        </>
      ) : (
        <PowerBIReportEmbed selectedData={selectedData} />
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  viewPowerBi: state.viewPowerBi.viewPowerBiAlerts,
});

const mapDispatchToProps = {
  setViewPowerBi,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewAllAlerts);
